module.exports = __webpack_public_path__ + "img/users.afca6573.svg";